// extracted by mini-css-extract-plugin
export default {"container":"CookieSection_container__s2-jh","title":"CookieSection_title__Hlm5v","description":"CookieSection_description__ZX6sU"};